import AuthContext from '../../context/AuthContext';
import WithGASetup from '../WithGASetup';
import Payment from './Payment';

export default WithGASetup(Payment, AuthContext);
